import developerIcon from '@/assets/developer.svg'

/** 应用未设置图标时的默认图标 */
export const DEFAULT_APP_ICON: string = developerIcon

/** 应用图标是可渲染的图片地址（含本地预览 data URL / blob URL） */
export function isAppIconSrc(icon: string): boolean {
  return (
    /^https?:\/\//i.test(icon) ||
    icon.startsWith('/') ||
    icon.startsWith('data:image/') ||
    icon.startsWith('blob:')
  )
}
